import React, {
    useEffect,
    forwardRef,
    useState,
    useRef,
    useImperativeHandle,
} from "react";

const PrefixedInput = forwardRef(({ prefix, value: _value }, ref) => {
    const [value, setValue] = useState(_value);
    const refInput = useRef(null);

    useEffect(() => {
        // focus on the input
        refInput.current.focus();
    }, []);

    useEffect(() => {
        let input = value;
        // a user tries to delete prefix
        if (prefix.startsWith(input)) input = prefix;
        // a user pasted a value
        else if (!input.startsWith(prefix)) input = `${prefix}${input}`;

        setValue(input);
    }, [value, prefix]);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return value;
            },

            isCancelBeforeStart() {
                return false;
            },

            isCancelAfterEnd() {
                return false;
            },
        };
    });

    return (
        <input
            type="text"
            ref={refInput}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            style={{ width: "100%", backgroundColor: "unset", border: "none" }}
        />
    );
});

export default PrefixedInput;
